import { CamAddEditIncident, CamIncidentMgmt } from "@/pages";
import { routes } from "../utils";
import { PermissionGuard } from "@/components";
import { actionsKeys } from "@/lib/utils";

export const IncidentMgmtRoutes = () => {
  return {
    path: routes.incidentMgmt,
    children: [
      {
        path: "",
        element: <PermissionGuard moduleKey={actionsKeys.INCIDENT_MANAGEMENT}>
            <CamIncidentMgmt />
          </PermissionGuard>,
      },
      {
        path: routes.add,
        element: <PermissionGuard moduleKey={actionsKeys.INCIDENT_MANAGEMENT} action={routes.add}>
            <CamAddEditIncident />
          </PermissionGuard>,
      },
      {
        path: routes.id + "/" + routes.action,
        element: <PermissionGuard moduleKey={actionsKeys.INCIDENT_MANAGEMENT}>
            <CamAddEditIncident />
          </PermissionGuard>,
      },
    ],
  };
};
